/*
UploadedPhotos.jsx
The "Scanned from original photo(s)" block on the Detail page. A recipe
photographed across several cookbook pages shows every page, in order.
*/

import React, { useState } from "react";
import PropTypes from "prop-types";

export const UploadedPhotos = ({ urls }) => {
  const [failedUrls, setFailedUrls] = useState(() => new Set());

  // Drop pages that failed to load. If every one of them does, the whole
  // block disappears.
  const visibleUrls = urls.filter((url) => !failedUrls.has(url));
  if (visibleUrls.length === 0) {
    return null;
  }

  const markFailed = (url) =>
    setFailedUrls((prev) => new Set(prev).add(url));

  const isMultiPage = visibleUrls.length > 1;

  return (
    <div className="detail-uploaded-image-container">
      <div className="detail-uploaded-image-label">
        {isMultiPage ? "Scanned from original photos" : "Scanned from original photo"}
      </div>
      {isMultiPage ? (
        <div className="detail-uploaded-image-strip">
          {visibleUrls.map((url, index) => (
            <img
              key={`${url}-${index}`}
              src={url}
              className="detail-uploaded-image-page"
              alt={`Original uploaded recipe photo, page ${index + 1} of ${visibleUrls.length}`}
              onError={() => markFailed(url)}
            />
          ))}
        </div>
      ) : (
        <img
          src={visibleUrls[0]}
          className="detail-uploaded-image"
          alt="Original uploaded recipe photo"
          onError={() => markFailed(visibleUrls[0])}
        />
      )}
    </div>
  );
};

UploadedPhotos.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.string).isRequired,
};
